const lodash = require('lodash');

export const formatingAddworkerData = (travailleursFormData, reserveFromData, editedFlagUser, branchSelectedValue = {}, roleSelectedValue = {}, orgId = '', userType = 'admin') => {
    console.log("travailleursFormData==========", travailleursFormData)
    // console.log("reserveFromData==========", reserveFromData)
    let promise = new Promise((resolve, reject) => {
        let userDetailHash = {};
        let user_details = {};
        if (!editedFlagUser) {
            // console.log("iffffffffff==========")
            user_details['first_name'] = travailleursFormData.firstName != "" ? travailleursFormData.firstName.trim() : "";
            user_details['last_name'] = travailleursFormData.name != "" ? travailleursFormData.name.trim() : "";
            user_details['email'] = travailleursFormData.email != "" ? travailleursFormData.email.trim() : "";
            if (Object.keys(travailleursFormData.profileImage).length > 0) {
                user_details['profile_img_url'] = travailleursFormData.profileImage;
            }
            user_details['contact_number'] = travailleursFormData.phone_number != "" ? travailleursFormData.phone_number.trim() : "";
            user_details['user_type'] = travailleursFormData.user_type.value != 0 ? travailleursFormData.user_type.value : 0;;
            user_details['status'] = true;
            user_details['org_id'] = travailleursFormData.selectedOrganisation.value != 0 ? travailleursFormData.selectedOrganisation.value : 0;

            userDetailHash['user_details'] = user_details;
            let user_relation_info = {};
            user_relation_info['org_id'] = travailleursFormData.selectedOrganisation.value != 0 ? travailleursFormData.selectedOrganisation.value : 0;
            userDetailHash['user_relation_info'] = user_relation_info;
            // if (['admin','staff'].includes(this.props.userCredentials.user_details.user_type)) {
            if (branchSelectedValue && Object.keys(branchSelectedValue).length > 0) {
                user_details['branch_id'] = branchSelectedValue.value;
            }
            if (roleSelectedValue && Object.keys(roleSelectedValue).length > 0) {
                user_details['role_id'] = roleSelectedValue.value;
            }
            // }
            if (orgId != "") {
                user_details['org_ids'] = [orgId]
            }
            resolve(userDetailHash)
        } else {
            // console.log("elseeeeee==========")
            if (travailleursFormData.firstName != reserveFromData.firstName) {
                user_details['first_name'] = travailleursFormData.firstName.trim()
            }
            if (travailleursFormData.name != reserveFromData.name) {
                user_details['last_name'] = travailleursFormData.name.trim()
            }
            if (travailleursFormData.phone_number != reserveFromData.phone_number) {
                user_details['contact_number'] = travailleursFormData.phone_number.trim()
            }

            if (travailleursFormData.profileImage != "") {
                user_details['profile_img_url'] = travailleursFormData.profileImage;
                //let isBase64Data = isBase64(travailleursFormData.profileImage.file_obj)
                //console.log("isBase64Data===========",isBase64Data)
            }
            console.log('userType=====>',userType)
            if (userType == 'user') {
                if (branchSelectedValue && Object.keys(branchSelectedValue).length > 0) {
                    user_details['branch_id'] = branchSelectedValue.value;
                }
                if (roleSelectedValue && Object.keys(roleSelectedValue).length > 0) {
                    user_details['role_id'] = roleSelectedValue.value;
                }
            }
            if (orgId != "") {
                user_details['org_ids'] = [orgId]
            }
            userDetailHash['user_details'] = user_details;
            resolve(userDetailHash)
        }

    })
    return promise;

};

const isBase64 = (str) => {
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
    return base64Regex.test(str) && str.length % 4 === 0;
}

const difference = (origObj, newObj) => {
    let changes = (newObj, origObj) => {
        let arrayIndexCounter = 0
        return lodash.transform(newObj, (result, value, key) => {

            if (!lodash.isEqual(value, origObj[key])) {
                let resultKey = lodash.isArray(origObj) ? arrayIndexCounter++ : key
                result[resultKey] = (lodash.isObject(value) && lodash.isObject(origObj[key])) ? changes(value, origObj[key]) : value
            }
        })
    }
    return changes(newObj, origObj)
}